import styled from 'styled-components';

export const SearchSectionWrapper = styled.div`
  display: flex;
  margin: 16px 0;
  & > * + * {
    margin-inline-start: 10px;
  }
`;

export const SearchBarWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const SearchBarInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 8px 36px;
  font-size: 13px;
  line-height: 20px;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.grey002};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey001};
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    // border: none;
    outline: none;
  }
`;

export const SearchBarIcon = styled.i`
  position: absolute;
  top: 9px;
  left: 13px;
  color: ${({ theme }) => theme.colors.grey002};
  font-style: normal;

  &:before {
    content: '\\e905';
    font-family: 'Icomoon';
  }
`;
